import React from "react";

const Header = ({ heroImage }) => (
  <div className="mx-auto w-full main-logo">
    <img src={heroImage} alt="Bardem" />
  </div>
);

export default Header;
